import React from 'react';

// Components
import MuiKpiPaper from '../../../../components/muikpipaper';
// Models
import type { KpiGrid } from '../../../../models/operationsmodels/KpiModels';

interface PeopleProps {
  /** Pre-fetched data for print view — skips Redux read when provided */
  data?: KpiGrid[];
  /** When true, renders all grids flat without tabs or interactive controls */
  isPrintView?: boolean;
}

/**
 * People Component - Wrapper for People KPI display
 */
const People: React.FC<PeopleProps> = ({ data, isPrintView }) => {
  return <MuiKpiPaper cardTitle="People" data={data} isPrintView={isPrintView} />;
};

export default People;
